<template>
  <v-container
    grid-list-md
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md8
      >
        <MaterialCard
          color="green"
          full-width
        >
          <v-data-table
            :headers="headers"
            :items="tankTypes"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <tr
                :active="item.id === selected.id"
                @click="selected = item"
              >
                <td>{{ item.tankTypeCode }}</td>
                <td>{{ item.tankName }}</td>
                <td>{{ item.makerName }}</td>
                <td>{{ item.tankMaxVolume }}</td>
                <td>{{ item.tankHeight }}</td>
                <td>{{ item.remarks }}</td>
              </tr>
            </template>
          </v-data-table>
        </MaterialCard>
      </v-flex>
      <v-flex
        column
        md4
        xs3
        mt-0
      >
        <BlackBtn
          v-if="!readonly"
          class="mb-2"
          style="align-self: flex-end;"
          @click="selected = {id:'new'}"
        >
          <v-icon left>
            mdi-shape-square-plus
          </v-icon>
          タンクタイプを追加
        </BlackBtn>
        <TankTypeDetail
          v-if="!!selected.id"
          :tank-type="selected"
          :readonly="readonly"
          @register="onRegister"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { api } from '@/api'
import { mapState, mapActions } from 'vuex'
import { TankTypeDetail } from './components'
import { BlackBtn } from '@/components/ui'

export default {
  components: {
    TankTypeDetail,
    BlackBtn
  },
  data: () => ({
    headers: [
      { sortable: false, text: 'コード', value: 'tankTypeCode' },
      { sortable: false, text: 'タンク名', value: 'tankName' },
      { sortable: false, text: 'メーカー名', value: 'makerName' },
      { sortable: false, text: '法定容量', value: 'tankMaxVolume' },
      { sortable: false, text: '高さ', value: 'tankHeight' },
      { sortable: false, text: '備考', value: 'remarks' }
    ],
    selected: {}
  }),
  computed: {
    ...mapState('tankTypes', ['tankTypes']),
    readonly () {
      return this.$store.state.app.user.roleId !== 4
    }
  },
  mounted () {
    if (!this.selected.id && this.tankTypes.length) this.selected = this.tankTypes[0]
  },
  methods: {
    ...mapActions('tankTypes', ['setTankTypes']),
    async onRegister (data) {
      let snackBarText = '更新'
      if (data.id === 'new') {
        snackBarText = '追加'
        const { id } = await api.createTankTypes(data)
        data.id = id
      } else {
        await api.updateTankType(data, data.id)
      }
      this.$store.commit('app/setGlobalSnackBarText', `タンクタイプを${snackBarText}しました。`)

      await this.setTankTypes()

      this.selected = this.tankTypes.find(e => e.id === data.id)
    }
  }
}
</script>
